require('./isLoading');
require('./string');
require('./setStyles');
require('./swiper');